export const CONFIG = {
  "version": "1.0.158"
}
